import { render, staticRenderFns } from "./MaterialPanel.vue?vue&type=template&id=10ff239c&scoped=true"
import script from "./MaterialPanel.vue?vue&type=script&lang=js"
export * from "./MaterialPanel.vue?vue&type=script&lang=js"
import style0 from "./MaterialPanel.vue?vue&type=style&index=0&id=10ff239c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ff239c",
  null
  
)

export default component.exports